import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DataGridPro, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';


const GreatnessTracker = ( { aid, meta, user, viewing, canExport, opps, loans, tasks, comms, events, gifts, start, end } ) => {
    const [ colsSource, setColsSource ] = useState( [] );
    const [ leads, setLeads ] = useState( { id: 'leads' } );
    const [ apps, setApps ] = useState( { id: 'apps' } );
    const [ pas, setPAs ] = useState( { id: 'pas' } );
    const [ locks, setLocks ] = useState( { id: 'locks' } );
    const [ funded, setFunded ] = useState( { id: 'funded' } );
    const [ gs, setGifts ] = useState( { id: 'gifts' } );
    const [ calls, setCalls ] = useState( { id: 'calls' } );
    const [ f2f, setF2F ] = useState( { id: 'f2f' } );
    const [ bread, setBread ] = useState( { id: 'bread' } );
    const [ evs, setEvs ] = useState( { id: 'events' } );
    const [ videos, setVideos ] = useState( { id: 'videos' } );
    const [ tys, setTYs ] = useState( { id: 'tys' } );
    const [ rows, setRows ] = useState( [] );

    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    <Row className='p-0 align-items-center w-100'>
                        <Col></Col>
                        {
                            ( canExport ) ? (
                                <Col xs='auto' className='pe-3 text-right'>
                                    <GridToolbarExport />
                                </Col>
                            ) : (
                                null
                            )
                        }
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }

    useEffect( () => {
        if ( start && end ) {
            let cols = [ { field: 'milestone', headerName: '', flex: 1, minWidth: 100, cellClassName: 'tf-metrics-grid-row-label' } ];

            const ed = new Date( end + 'T12:00:00.000' );
            let tmp = new Date( start + 'T12:00:00.000' );
            do {
                cols.push( {
                    field: tmp.toLocaleDateString(),
                    headerName: tmp.toLocaleDateString(),
                    flex: 1,
                    minWidth: 85
                } );
                tmp.setDate( tmp.getDate() + 1 );
            } while ( tmp.getTime() <= ed.getTime() );

            cols.push( { field: 'total', headerName: 'Total', flex: 1, minWidth: 75, cellClassName: 'tf-metrics-grid-total' } );
            
            setColsSource( cols );
        }
    }, [ start, end ] );

    useEffect( () => {
        setRows( [ calls, f2f, bread, evs, videos, tys, leads, apps, pas, locks, funded, gs ] );
    }, [ calls, f2f, bread, evs, videos, tys, leads, apps, pas, locks, funded, gs ] );

    useEffect( () => {
        let row = { id: 'leads', milestone: 'Leads', total: 0 };
        
        const sd = new Date( start + 'T12:00:00.000' );
        const ed = new Date( end + 'T12:00:00.000' );
        let tmp = new Date( start + 'T12:00:00.000' );
        do {
            row[tmp.toLocaleDateString()] = 0;
            tmp.setDate( tmp.getDate() + 1 );
        } while ( tmp.getTime() <= ed.getTime() );
        
        if ( opps ) {
            Object.keys( opps ).forEach( loid => {
                const lo = opps[loid];
                if ( !viewing.includes( lo.aid ) ) {
                    return;
                }

                if ( lo.oppDate ) {
                    const od = new Date( lo.oppDate + 'T12:00:00.000' );
                    if ( od.getTime() >= sd.getTime() && od.getTime() <= ed.getTime() ) {
                        row[od.toLocaleDateString()]++;
                        row.total++;
                    }
                }
            } );
        }

        setLeads( row );
    }, [ opps, start, end, viewing ] );

    useEffect( () => {
        let c = { id: 'calls', milestone: 'Calls', total: 0 };
        let f = { id: 'f2f', milestone: 'F2F', total: 0 };
        let b = { id: 'bread', milestone: 'Break Bread', total: 0 };
        let e = { id: 'events', milestone: 'Events', total: 0 };
        let v = { id: 'video', milestone: 'Videos', total: 0 };
        let ty = { id: 'tys', milestone: 'Thank Yous', total: 0 };

        const sd = new Date( start + 'T12:00:00.000' );
        const ed = new Date( end + 'T12:00:00.000' );
        let tmp = new Date( start + 'T12:00:00.000' );
        do {
            c[tmp.toLocaleDateString()] = 0;
            f[tmp.toLocaleDateString()] = 0;
            b[tmp.toLocaleDateString()] = 0;
            e[tmp.toLocaleDateString()] = 0;
            v[tmp.toLocaleDateString()] = 0;
            ty[tmp.toLocaleDateString()] = 0;
            tmp.setDate( tmp.getDate() + 1 );
        } while ( tmp.getTime() <= ed.getTime() );

        if ( tasks ) {
            Object.keys( tasks ).forEach( tid => {
                const t = tasks[tid];
                if ( !viewing.includes( t.aid ) ) {
                    return;
                }

                if ( t.completedDate ) {
                    const cd = new Date( t.completedDate );
                    cd.setHours( 12, 0, 0, 0 );
                    if ( cd.getTime() >= sd.getTime() && cd.getTime() <= ed.getTime() ) {
                        switch ( t.type ) {
                            case 'Call':
                                c[cd.toLocaleDateString()]++;
                                c.total++;
                                break;

                            case 'Meeting':
                                f[cd.toLocaleDateString()]++;
                                f.total++;
                                break;

                            case 'Meal':
                                b[cd.toLocaleDateString()]++;
                                b.total++;
                                break;

                            case 'Thank You':
                                ty[cd.toLocaleDateString()]++;
                                ty.total++;
                                break;

                            default:
                        }
                    }
                }
            } );
        }

        setCalls( c );
        setF2F( f );
        setBread( b );
        setEvs( e );
        setVideos( v );
        setTYs( ty );
    }, [ tasks, start, end, viewing ] );

    useEffect( () => {
        let apps = { id: 'apps', milestone: 'Apps', total: 0 };
        let pas = { id: 'pas', milestone: 'PAs', total: 0 };
        let locks = { id: 'locks', milestone: 'Locks', total: 0 };
        let funded = { id: 'funded', milestone: 'Funded', total: 0 };

        const sd = new Date( start + 'T12:00:00.000' );
        const ed = new Date( end + 'T12:00:00.000' );
        let tmp = new Date( start + 'T12:00:00.000' );
        do {
            apps[tmp.toLocaleDateString()] = 0;
            pas[tmp.toLocaleDateString()] = 0;
            locks[tmp.toLocaleDateString()] = 0;
            funded[tmp.toLocaleDateString()] = 0;
            tmp.setDate( tmp.getDate() + 1 );
        } while ( tmp.getTime() <= ed.getTime() );

        if ( loans ) {
            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];

                if ( !viewing.includes( l.aid ) ) {
                    return;
                }
                
                // App
                if ( l.appCompletedDate ) {
                    const acd = new Date( l.appCompletedDate.match( 'T' ) ? l.appCompletedDate : l.appCompletedDate + 'T12:00:00.000Z' );
                    acd.setHours( 12, 0, 0, 0 );
                    
                    if ( acd && acd.getTime() >= sd.getTime() && acd.getTime() <= ed.getTime() ) {
                        // console.log( l.appCompletedDate + ' -> ' + acd.toLocaleDateString() );
                        apps[acd.toLocaleDateString()]++;
                        apps.total++;
                    }
                }

                // PA
                if ( l.paDate ) {
                    const pad = new Date( l.paDate.match( 'T' ) ? l.paDate : l.paDate + 'T12:00:00.000Z' );
                    pad.setHours( 12, 0, 0, 0 );
                    
                    if ( pad && pad.getTime() >= sd.getTime() && pad.getTime() <= ed.getTime() ) {
                        pas[pad.toLocaleDateString()]++;
                        pas.total++;
                    }
                }

                // Locks
                if ( l.rateLockDate ) {
                    const rld = new Date( l.rateLockDate.match( 'T' ) ? l.rateLockDate : l.rateLockDate + 'T12:00:00.000Z' );
                    rld.setHours( 12, 0, 0, 0 );

                    if ( rld && rld.getTime() >= sd.getTime() && rld.getTime() <= ed.getTime() ) {
                        // console.log( '***** ' + l.lid + ' - rld is: ' + l.rateLockDate + ' => ' + rld.toLocaleDateString() );
                        locks[rld.toLocaleDateString()]++;
                        locks.total++;
                    }
                }

                // Funded
                if ( l.fundedDate ) {
                    const fd = new Date( l.fundedDate.match( 'T' ) ? l.fundedDate : l.fundedDate + 'T12:00:00.000Z' );
                    fd.setHours( 12, 0, 0, 0 );

                    if ( fd.getTime() >= sd.getTime() && fd.getTime() <= ed.getTime() ) {
                        console.log( l.lid + ': funded on ' + l.fundedDate )
                        funded[fd.toLocaleDateString()]++;
                        funded.total++;
                    }
                }
            } );
        }

        setApps( apps );
        setPAs( pas );
        setLocks( locks );
        setFunded( funded );
    }, [ loans, start, end, viewing ] );

    useEffect( () => {
        let g = { id: 'gifts', milestone: 'Gifts', total: 0 };
        
        const sd = new Date( start + 'T12:00:00.000' );
        const ed = new Date( end + 'T12:00:00.000' );
        let tmp = new Date( start + 'T12:00:00.000' );
        do {
            g[tmp.toLocaleDateString()] = 0;
            tmp.setDate( tmp.getDate() + 1 );
        } while ( tmp.getTime() <= ed.getTime() );

        if ( gifts ) {
            Object.keys( gifts ).forEach( gid => {
                const gift = gifts[gid];
                if ( !viewing.includes( gift.aid ) ) {
                    return;
                }

                if ( gift.giftDate ) {
                    const cd = new Date( gift.giftDate.match( 'T' ) ? gift.giftDate : gift.giftDate + 'T12:00:00.000' );
                    cd.setHours( 12, 0, 0, 0 );
                    if ( cd.getTime() >= sd.getTime() && cd.getTime() <= ed.getTime() ) {
                        g[cd.toLocaleDateString()]++;
                        g.total++;
                    }
                }
            } );
        }

        setGifts( g );
    }, [ gifts, start, end, viewing ] );

    return (
        <Container fluid>
            <Row>
                <Col className='p-0'>
                    <DataGridPro
                        rows={ rows }
                        columns={ colsSource }
                        disableSelectionOnClick
                        hideFooter={ true }
                        autoHeight={ true }
                        rowHeight={ 40 }
                        slots={ { toolbar: toolbar } }
                        initialState={ { pinnedColumns: { left: [ 'milestone' ] } } }
                    />
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    meta: state.user.meta,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    opps: state.leadopps.byId,
    loans: state.loans.byId,
    tasks: state.tasks.byId,
    comms: state.comms.byId,
    events: state.events.byId,
    gifts: state.gifts.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( GreatnessTracker );